import React from 'react';

function SortBy({ onSorted }) {
	return (
		<div className='listing sort-by'>
			<h4>Sort By</h4> 
			<select
				onChange={e => {
					if (typeof onSorted === 'function') {
						onSorted(e.target.value);
					}
				}}>
				<option value='rand'>Featured</option>
				<option value='p_asc'>Price: Low to High</option>
				<option value='p_desc'>Price: High to Low</option>
				<option value='n_asc'>Name: A to Z</option>
				<option value='n_desc'>Name: Z to A</option>
			</select>
		</div>
	);
}

export default SortBy;
